let _serverWeekNumber = null;

export const setServerWeekNumber = (weekNumber) => { _serverWeekNumber = weekNumber; };

export const getWeekNumber = (d) => {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

export const formatDate = (date) => {
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const getDateByWeekAndDay = (weekNumber, dayOfWeek) => {
  const today = new Date();
  const todayDayOfWeek = today.getDay() || 7;
  const currentMonday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  currentMonday.setDate(currentMonday.getDate() - (todayDayOfWeek - 1));
  const refWeek = _serverWeekNumber || getWeekNumber(today);
  const weekDiff = weekNumber - refWeek;
  const targetDate = new Date(currentMonday);
  targetDate.setDate(currentMonday.getDate() + weekDiff * 7 + (dayOfWeek - 1));
  return targetDate;
};

export const isToday = (date) => {
  const today = new Date();
  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};
